import React from 'react';
import Icon from 'components/AppIcon';


const CertificationSection = () => {
  const certifications = {
    title: "Certificaciones y Licencias",
    subtitle: "Professional Certifications & Licenses",
    description: "Nuestro compromiso con la excelencia se refleja en nuestras certificaciones profesionales y cumplimiento regulatorio en Costa Rica.",
    items: [
      {
        title: "Registro Empresarial CCSS",
        description: "Empresa registrada ante la Caja Costarricense de Seguro Social",
        icon: "FileCheck",
        verified: true,
        number: "REG-2024-001234"
      },
      {
        title: "Licencia Municipal",
        description: "Patente comercial vigente para servicios de limpieza",
        icon: "Building",
        verified: true,
        number: "LIC-SJ-2024-5678"
      },
      {
        title: "Seguro de Responsabilidad Civil",
        description: "Cobertura completa para protección del cliente",
        icon: "Shield",
        verified: true,
        number: "POL-INS-2024-9012"
      },
      {
        title: "Certificación en Manejo de Químicos",
        description: "Personal certificado en manejo seguro de productos químicos",
        icon: "Beaker",
        verified: true,
        number: "CERT-CHEM-2024"
      },
      {
        title: "Certificación Ambiental",
        description: "Compromiso con prácticas ambientalmente responsables",
        icon: "Leaf",
        verified: true,
        number: "ENV-CERT-2024"
      },
      {
        title: "Asociación de Empresarios",
        description: "Miembro activo de la Cámara de Comercio de Costa Rica",
        icon: "Users",
        verified: true,
        number: "MEMBER-2024-3456"
      }
    ]
  };

  return (
    <section className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
          {certifications.title}
        </h2>
        <p className="text-lg text-text-secondary font-medium mb-6">
          {certifications.subtitle}
        </p>
        <p className="max-w-3xl mx-auto text-text-secondary">
          {certifications.description}
        </p>
      </div>

      {/* Certifications Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {certifications.items.map((cert, index) => (
          <div key={index} className="bg-surface p-6 rounded-lg border border-border shadow-subtle hover:shadow-medium nav-transition">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={cert.icon} size={24} className="text-primary" />
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <h3 className="font-heading font-semibold text-text-primary">
                    {cert.title}
                  </h3>
                  {cert.verified && (
                    <div className="w-5 h-5 bg-success rounded-full flex items-center justify-center">
                      <Icon name="Check" size={12} color="white" />
                    </div>
                  )}
                </div>
                <p className="text-sm text-text-secondary mb-3">
                  {cert.description}
                </p>
                <div className="text-xs font-mono text-primary bg-primary/5 px-2 py-1 rounded">
                  {cert.number}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Trust Indicators */}
      <div className="bg-primary/5 rounded-lg p-8">
        <div className="grid md:grid-cols-3 gap-8 text-center">
          <div>
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="ShieldCheck" size={32} className="text-primary" />
            </div>
            <h3 className="font-heading font-semibold text-text-primary mb-2">
              100% Asegurado en <a href="https://bacpoolcr.online">bacpoolcr.online</a>
            </h3>
            <p className="text-sm text-text-secondary">
              Cobertura completa de responsabilidad civil para su tranquilidad
            </p>
          </div>
          
          <div>
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Award" size={32} className="text-success" />
            </div>
            <h3 className="font-heading font-semibold text-text-primary mb-2">
              Certificado Profesional en  <a href="https://bacpoolcr.online">bacpoolcr.online</a>
            </h3>
            <p className="text-sm text-text-secondary">
              Personal capacitado y certificado en las mejores prácticas
            </p>
          </div>
          
          <div>
            <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Leaf" size={32} className="text-accent" />
            </div>
            <h3 className="font-heading font-semibold text-text-primary mb-2">
              Eco-Responsable en <a href="https://bacpoolcr.online">bacpoolcr.online</a>
            </h3>
            <p className="text-sm text-text-secondary">
              Comprometidos con el cuidado del medio ambiente costarricense
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationSection;
